import React from "react";
import "./information.css";
import { Button } from "../../components";

function Information() {
  return (
    <main className="api-information">
      <div className="corp">
        <div className="corp-desc">
          <div className="headers">
            <h2>راهنمای دریافت کلید دسترسی</h2>
            <h3>و ثبت‌نام در مپ</h3>
          </div>
          <p>برای دریافت کلید دسترسی می‌توانید به آدرس‌ زیر بروید:</p>
          <div className="button-container">
            <Button secondary>مشاهده‌ ویدئوی آموزشی</Button>
            <a href="https://corp.map.ir/"
          target="_blank"
          rel="noopener noreferrer"><Button>corp.map.ir</Button></a>
          </div>
          <p>
            سپس با انتخاب «رایگان شروع کنید» از منو، مطابق تصاویر بعدی ثبت‌نام
            کنید یا وارد شوید.
          </p>
        </div>
        <div className="corp-bg"></div>
      </div>
      <div className="login">
        <div className="login-desc">
          <p>
            از طریق این منو ثبت نام کنید و یا اگر حساب کاربری دارید، وارد حساب
            خود شوید.
          </p>
        </div>
        <div className="login-bg"></div>
      </div>
      <div className="copy-token">
        <div className="copy-project-bg"></div>
        <div className="copy-token-desc">
          <p>در صورتی که پروژه‌ای تعریف کرده‌اید، وارد یکی از پروژه‌ها شوید.</p>
          <p>
            توکن یا همان کلید دسترسی را با یک کلیک کپی و در محل مورد در خواست
            باز نشانی کنید.
          </p>
          <div className="copy-token-bg"></div>
        </div>
      </div>
      <div className="create-project">
        <div className="create-project-desc">
          <p>
            اگر تاکنون پروژه‌ای نساخته‌اید، می‌توانید از این قسمت پروژه جدیدی
            تعریف و بعد مطابق تعریف بالا مسیر دریافت کلید دسترسی را طی کنید.
          </p>

          <div className="create-project2-bg"></div>
        </div>
        <div className="create-project-bg"></div>
      </div>
    </main>
  );
}

export default Information;
